import React, {useState} from "react"

import {OperationTypes, SUCCESS_TIMEOUT, useFuelCard} from "./useFuelCard"
import "./fuelcard.scss"
import {useConfigHeader} from "hooks/useConfig"

const Actions = {
  Add: "Add",
  Edit: "Edit",
  List: "List",
}

const CardType = "Fuel"

const FuelCard = () => {
  const [message, setMessage] = useState({
    type: "",
    message: "",
  })
  const {allowFuelCard, fuelCardMinLength, fuelCardMaxLength} = useConfigHeader()

  const [action, setAction] = useState(Actions.List)
  const [fuelCardNo, setFuelCardNo] = useState("")
  const [editCardObj, setEditCardObj] = useState({})
  const [canShowError, setCanShowError] = useState(false)

  const {data: cards, isLoading, saveMutation} = useFuelCard()
  const {mutate: saveFuelCard, isPending: isSaving} = saveMutation

  if (!allowFuelCard) {
    return null
  }

  const lengthError =
    fuelCardNo.length < fuelCardMinLength ||
    fuelCardNo.length > fuelCardMaxLength
      ? `Fuel card number must be between ${fuelCardMinLength} to ${fuelCardMaxLength} digits`
      : ""

  const handleSave = async () => {
    setCanShowError(true)
    if (lengthError) {
      return
    }

    const successCallback = () => {
      setTimeout(() => {
        setAction(Actions.List)
        setFuelCardNo("")
        setCanShowError(false)
      }, SUCCESS_TIMEOUT)
    }

    if (action === Actions.Edit) {
      saveFuelCard({
        data: {
          CurrentCardId: editCardObj.CardId,
          CurrentCardNumber: editCardObj.CardNumber,
          NewCardNumber: fuelCardNo,
          CardType,
          operation: OperationTypes.EDIT,
        },
        setMessage,
        successCallback,
      })
      return
    }

    saveFuelCard({
      data: {
        CardNumber: fuelCardNo,
        CardType,
        operation: OperationTypes.ADD,
      },
      setMessage,
      successCallback,
    })
  }

  function getSaveButtonText() {
    if (action === Actions.Edit) {
      if (isSaving) {
        return "Updating..."
      }
      return "Update"
    }

    if (isSaving) {
      return "Saving..."
    }
    return "Save"
  }

  return (
    <>
      <div className="fuel-section-theme2">
        <div className="page-title">
          <h1>Fuel Card</h1>
          {action === Actions.List ? (
            <div className="top-action-btn">
              <button onClick={() => setAction(Actions.Add)}>Add</button>
            </div>
          ) : null}
        </div>

        {action === Actions.List ? (
          <SavedCards
            cards={cards}
            onEditBack={cardObj => {
              setEditCardObj(cardObj)
              setAction(Actions.Edit)
              setFuelCardNo(cardObj?.CardNumber)
            }}
            isLoading={isLoading}
            saveFuelCard={saveFuelCard}
            isRemoving={isSaving}
          />
        ) : (
          <>
            <div className="fuel-card-container">
              <div className="fuel-card-input-box">
                <label>Fuel Card Number</label>
                <div className="fuel-card-input-group form-control">
                  <input
                    type="text"
                    name="fuelcardnub"
                    id="fuelcardnub"
                    className="fuel-card-input"
                    placeholder="Enter Fuel Card Number"
                    value={fuelCardNo}
                    maxLength={fuelCardMaxLength}
                    minLength={fuelCardMinLength}
                    onChange={e => {
                      const value = e.target.value.replace(/[^0-9]/g, "")
                      setFuelCardNo(value)
                    }}
                  />
                </div>
              </div>
              <div className="submit-btn">
                {cards?.length ? (
                  <button
                    type="button"
                    className="cancel-btn"
                    disabled={isSaving}
                    onClick={() => setAction(Actions.List)}
                  >
                    Cancel
                  </button>
                ) : null}

                <button
                  type="submit"
                  className="save-btn"
                  onClick={handleSave}
                  disabled={isSaving}
                >
                  {getSaveButtonText()}
                </button>
              </div>
            </div>
            {(message.message || lengthError) && canShowError && (
              <p
                style={{
                  color: message.type === "error" || lengthError ? "red" : "green",
                  marginTop: "10px",
                }}
              >
                {message.message || lengthError}
              </p>
            )}
          </>
        )}
      </div>
    </>
  )
}

const SavedCards = ({
  cards,
  onEditBack,
  saveFuelCard,
  isRemoving,
  isLoading,
}) => {
  const [deleteCardId, setDeleteCardId] = useState()

  const handleRemove = card => {
    setDeleteCardId(card.CardId)
    saveFuelCard({
      data: {
        CardId: card.CardId,
        operation: OperationTypes.DELETE,
      },
      setMessage: () => {},
      successCallback: () => {
        setDeleteCardId(null)
      },
    })
  }

  if (isLoading) {
    return (
      <div className="my-fuel-card-container">
        <p className="loading-text">Loading, please wait....</p>
      </div>
    )
  }

  return (
    <>
      <div>
        <div className="my-fuel-card-container">
          <div className="fuel-card-details">
            <div className="table-wrapper">
              <div className="scrollable">
                <table className="responsive">
                  <tbody>
                    <tr>
                      <th style={{textAlign: "left"}}>Fuel Card#</th>
                      <th></th>
                    </tr>
                    {!cards?.length ? (
                      <tr>
                        <td colSpan={2} style={{textAlign: "center"}}>
                          No fuel cards available
                        </td>
                      </tr>
                    ) : (
                      cards?.map((card, index) => {
                        const isDeleting =
                          isRemoving && deleteCardId === card.CardId
                        return (
                          <tr key={index} className="table-detail">
                            <td>{card?.CardNumber}</td>
                            <td style={{textAlign: "right"}}>
                              <div className="action-btn">
                                <button
                                  onClick={() => onEditBack(card)}
                                  disabled={isDeleting}
                                >
                                  Edit
                                </button>
                                <button
                                  disabled={isDeleting}
                                  className="delete"
                                  onClick={() => handleRemove(card)}
                                >
                                  {isDeleting ? "Removing..." : "Remove"}
                                </button>
                              </div>
                            </td>
                          </tr>
                        )
                      })
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default FuelCard
